Vue.component('PharmacyGroupIndexComponent', require('./components/PharmacyGroupsIndexComponent').default);
Vue.component('PharmacyGroupGetComponent', require('./components/PharmacyGroupFormComponent').default);
Vue.component('PharmacyGroupsDataTable', require('./components/partials/PharmacyGroupsDataTable').default);
Vue.component('StepperControl', require('./components/partials/StepperControl').default);

Vue.component('PharmacyGroupMainDetails', require('./components/partials/PharmacyGroupMainDetails').default);
Vue.component('PharmacyGroupChiefPharmacist', require('./components/partials/PharmacyGroupChiefPharmacist').default);
Vue.component(
    'PharmacyGroupTechnicianDetails',
    require('./components/partials/PharmacyGroupTechnicianDetails').default
);
Vue.component('PharmacyGroupPharmacySites', require('./components/partials/PharmacyGroupPharmacySites').default);
Vue.component('PharmacyGroupOutHours', require('./components/partials/PharmacyGroupOutHours').default);
Vue.component('PharmacyGroupActions', require('./components/partials/PharmacyGroupActions').default);
Vue.component(
    'PharmacyGroupPharmacySiteDataTable',
    require('./components/partials/PharmacyGroupPharmacySiteDataTable').default
);
